import React from 'react';

const Footnotes = () => {
  return (
    <div className="footnotes">
      <div className="footnotes__container">
        <div className="footnotes__row">
          <div className="superscript">
            <sup>1</sup>
          </div>
          <div className="footnote">
            <p>
              <span>The Edge Infrastructure Handbook</span>: 2021 Edition. Intel.{' '}
              <a
                href="https://www.intel.com/content/www/us/en/edge-computing/resources/edge-infrastructure-handbook.html"
                target="_blank"
                rel="noreferrer"
              >
                https://www.intel.com/content/www/us/en/edge-computing/resources/edge-infrastructure-handbook.html
              </a>
            </p>
          </div>
        </div>
        <div className="footnotes__row">
          <div className="superscript">
            <sup>2</sup>
          </div>
          <div className="footnote">
            <p>
              <a
                href="https://edc.intel.com/content/www/us/en/products/performance/benchmarks/3rd-generation-intel-xeon-scalable-processors/"
                target="_blank"
                rel="noreferrer"
              >
                See [84] at www.intel.com/3gen-xeon-config.{' '}
              </a>
              Results may vary.{' '}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footnotes;
